export default "__VITE_ASSET__CYqCq1fz__"